<ul class="menu-listing">
    <!-- <h3 class="listing-heading">Traveler details</h3> -->
    <li [class.active]="isActive('workflow-setting')" (click)="callByGtm()">
        <!-- <a [routerLink]="'/cam/approval-management/approval-listing'">
            <span>{{content?.['b2b.manageapproval.workflowsettings']}}</span>
            <span class="right-icon">
                <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
            </span>
        </a> -->
        <a [routerLink]=" workflowId ? ['/cam/approval-management/workflow-setting', workflowId] : ['/cam/approval-management/workflow-setting'] ">
            <span>{{content?.['b2b.manageapproval.workflowsettings']}}</span>
            <span class="right-icon">
                <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
            </span>
        </a>
    </li>

    <li [class.active]="isActive('approvalflow-form')">
        <a>
            <span>{{content?.['b2b.manageapproval.approvalflowsettings']}}</span>
            <span class="right-icon">
                <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
            </span>
        </a>
    </li>
</ul>

